export default "__VITE_ASSET__BDOG25rM__"